import React, { useContext } from "react";
import { LanguageContext } from "../../../../contexts/LanguageContext";
import { translations } from "../../../../translations";
import backgroundImage from "../../../../assets/background.jpg";

const Features = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const features = [
    {
      title: t.features.items.ai.title,
      description: t.features.items.ai.description,
      icon: "🧠",
    },
    {
      title: t.features.items.interactive.title,
      description: t.features.items.interactive.description,
      icon: "🧩",
    },
    {
      title: t.features.items.feedback.title,
      description: t.features.items.feedback.description,
      icon: "💭",
    },
    {
      title: t.features.items.management.title,
      description: t.features.items.management.description,
      icon: "⚙️",
    },
  ];

  return (
    <section className="features-section">
      <div className="features-content">
        <h2>{t.features.title}</h2>
        <p className="features-description">{t.features.description}</p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div
        className="features-image"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
    </section>
  );
};

export default Features;
